import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';

@Component({
  selector: 'mbs-payment-mode-hints',
  templateUrl: './payment-mode-hints.component.html',
  styleUrls: ['./payment-mode-hints.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [I18NextPipe]
})
export class PaymentModeHintsComponent {
  public compact = input(false);

  public isYearlyLicenseMode = inject(LicensesSignalFacade).isYearlyLicenseMode;

  public readonly elementsSelector = {
    name: {
      calendarRow: 'payment-mode-hints_calendar-row',
      creditCardRow: 'payment-mode-hints_credit-card-row',
      keyRow: 'payment-mode-hints_key-row'
    }
  };
}
